<div class="w-full ">
    <div class="!relative pb-[8px] header" cdkDrag [cdkDragDisabled]="true">
        <mat-toolbar class="background mb-1 value">
            <button mat-icon-button class="!flex justify-center" (click)="onDrawerClosed()" (keypress)="onDrawerClosed()" i18n-aria-label
                aria-label="close transport order details" role="button">
                <lib-app-icon id="close-transport-order-details" icon="x_icon" [size]="'24x12'" />
            </button>
            <h2 class="drawer-title mat-subtitle-1 flex-auto" i18n>Drive instructions</h2>
            <button i18n class="details-button details-background" (click)="navigateToTransportOrderDetails(transportOrderData())"> 
                Details
            </button>
        </mat-toolbar>
        <div class="mr-[16px] ml-[16px] flex items-center gap-2 pl-[16px] pt-[8px] pb-[8px] pr-[16px] rounded card-wrapper border border-[0.5px] border-[#71787E]">
            @if (transportOrderData().transportOrderId) {
                <pickup-planning-transport-order-card 
                    [isLocked]="this.isDisabled()"
                    [transportOrder]="transportOrderData()"
                    [displayInSingleLine]="false" 
                    labelsClass="text-[#71787E] not-italic text-xs !leading-[16px]"
                    textClass="drive-instructions-transport-order-details not-italic text-xs font-medium !leading-[16px]"
                />
            }
        </div>
    </div>
    <div class="scrollable">
        <div i18n class="tour-points-label ml-[16px]">
            Tour points
        </div>
        <div class="border-line ml-[16px] mr-[16px]">
            <mat-divider></mat-divider>
        </div>
        @if(this.getIsLoading()) {
            <div class="flex justify-center items-center h-[128px]">
                <mat-spinner diameter="80" />
            </div>
        } @else if (this.tourPoints.length === 0) {
            <div class="flex justify-center items-center h-[128px]">
                <span i18n>No tour points available</span>
            </div>
        } @else {
            <mat-list class="!p-[0px]">
                <div class="tourpoint-list"
                    [class.blur-sm]="getIsSilentUpdateInProgress()"
                    [class.pointer-events-none]="getIsSilentUpdateInProgress()"
                    cdkDropList
                    cdkScrollable
                    [cdkDropListData]="tourPoints"
                    (cdkDropListDropped)="dropTourPoint($event)"
                    [cdkDropListDisabled]="shouldDisableReordering()"
                    >
                    @for(tourPoint of tourPoints; track tourPoint.tourpointId) {
                        <mat-list-item 
                            class="flex items-center !h-auto draggable-item"
                            cdkDrag
                            [cdkDragDisabled]="shouldDisabledDrag(tourPoint.type)"
                            (cdkDragStarted)="dragStarted($index, tourPoint.tourpointId)"
                            [cdkDragData]="tourPoint"
                        >
                            <div class="border-line !pt-[8px] !pb-[8px]"
                            [class.pointer-events-none]="tourPoint.legCards && tourPoint.legCards.length === 0">
                                <div [class]="getTourPointClass(tourPoint.tourpointId)" >
                                    <div class="checkbox-column">
                                        <div class="tour-point-order grey-border">{{$index + 1}}</div>
                                    </div>
                                    <cal-group-tour-point [selected]="this.selectedTourPointId === tourPoint.tourpointId" [tourPointConfig]="tourPoint" class="!col-span-10 min-w-0"(clickHandler)="handleTourPointClick(tourPoint)" />
                                    @if (isExpandableTourPointType(tourPoint.type) && !getIsFromThirdPartySystem(tourPoint)) {
                                        <button (click)="handleTourPointClick(tourPoint)">
                                            <lib-app-icon icon="arrow_right" [size]="'16x16'" class="!col-span-1 value" className="value"/>
                                        </button>
                                    }
                                </div>
                            </div>
                        </mat-list-item>
                    }
                </div>
            </mat-list> 
        }
    </div>
</div>